import { render, staticRenderFns } from "./Paises.vue?vue&type=template&id=3cdddc9e&scoped=true&"
import script from "./Paises.vue?vue&type=script&lang=js&"
export * from "./Paises.vue?vue&type=script&lang=js&"
import style0 from "./Paises.vue?vue&type=style&index=0&id=3cdddc9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdddc9e",
  null
  
)

export default component.exports